import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { Form, Input, Table, Row, Col, DatePicker, Checkbox, Select, Card, TreeSelect } from 'antd';
import { Button, Modal } from '@/components';
import PageHeaderLayout from '../../component/page-header-layout/index';
import { getAllDistrictInfo } from '../../state/action/mergeSet';
import { marketList, getStallAnalyseData, getStallAnalyseDetail } from '../../state/action/stall';
import { STALL_TYPE } from '../../utils/deviceType';
import './dataAnalysis.less';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const DEFAULT_PAGE_SIZE = 10;
const QUERY_CACHE_KEY = 'STALL_ANALYSE_QUERY_CACHE';
const QUERY_FIELD_NAMES = [
  'businessCode',
  'name',
  'districtList',
  'marketIdList',
  'statisticDate',
  'pactStartTime',
  'createTime',
  'typeList',
  'activeStatusList',
  'sleepTime',
];
const DATE_FIELD_NAMES = ['statisticDate', 'pactStartTime', 'createTime', 'sleepTime'];
const DATE_FORMAT = 'YYYY-MM-DD 00:00:00';
const DEFAULT_STATISTIC_DATE = [
  moment().subtract(1, 'day').startOf('day'),
  moment().subtract(1, 'day').endOf('day'),
];
const ACTIVE_STATUS_MAP = {
  0: { text: '沉睡', color: 'red' },
  1: { text: '活跃', color: 'green' },
};
const VERSION_BADGE_CLASS_MAP = {
  '省心版': 'badge--jbn',
  '便捷版': 'badge--bjn',
  '基础版': 'badge--jcn',
  '标准版': 'badge--bzn',
  '专业版': 'badge--zyn',
  '旗舰版': 'badge--flagship',
};
const LOCKED_METRIC_BY_VERSION = {
  '便捷版': ['quickBillingCount', 'batchCount', 'batchSettlementCount', 'supplierPayCount'],
  '基础版': ['quickBillingCount', 'batchCount', 'batchSettlementCount', 'supplierPayCount'],
};
const VERSION_OPTIONS = [...STALL_TYPE].filter(([key]) => key !== 1);
const VERSION_MAP = new Map(VERSION_OPTIONS);
const METRIC_COLUMNS = [
  { title: '录赊欠（白条）', dataIndex: 'btOrderCount', width: 150, className: 'metric-nowrap-column' },
  { title: '买家还款', dataIndex: 'repaymentCount' },
  { title: '开单单量（不含白条）', dataIndex: 'orderNum', width: 200, className: 'metric-nowrap-column' },
  { title: '开单GMV(元)', dataIndex: 'gmv' },
  { title: '快速开单', dataIndex: 'quickBillingCount' },
  { title: '查看报表', dataIndex: 'reportViewCount' },
  { title: '入库', dataIndex: 'batchCount' },
  { title: '分享账单', dataIndex: 'creditShareCount' },
  { title: '班次交账', dataIndex: 'handCount' },
  { title: '代卖结算', dataIndex: 'batchSettlementCount' },
  { title: '货主打款', dataIndex: 'supplierPayCount' },
];

const toStartTime = (date) => (date ? moment(date.format(DATE_FORMAT)).valueOf() : null);
const toEndTime = (date) => (date ? moment(date.clone().add(1, 'day').format(DATE_FORMAT)).valueOf() : null);
const renderDate = (time) => (time && time !== 0 ? moment(time).format('YYYY-MM-DD') : '-');
const renderValue = (value) => (value || value === 0 ? value : '-');
const renderMetricValue = (value) => (value || value === 0 ? value : 0);

@connect(
  (state) => ({ stall: state.stall, mergeSet: state.mergeSet }),
  { marketList, getAllDistrictInfo, getStallAnalyseData, getStallAnalyseDetail },
)
@withRouter
@Form.create()
class DataAnalysis extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pageNo: 1,
      sortField: undefined,
      sortOrder: undefined,
      statisticQuickDays: 1,
      detailVisible: false,
      detailLoading: false,
      detailRecord: null,
      detailRows: [],
      detailQueryStartTime: null,
      detailQueryEndTime: null,
    };
  }

  componentDidMount() {
    this.getMarketList();
    this.getAllDistrictInfo();
    if (!this.restoreQueryCache()) {
      this.getStallAnalyseData(this.getSearchParams(1));
    }
  }

  saveQueryCache = () => {
    window.sessionStorage.setItem(
      QUERY_CACHE_KEY,
      JSON.stringify({
        fieldsValue: this.props.form.getFieldsValue(QUERY_FIELD_NAMES),
        pageNo: this.state.pageNo,
        sortField: this.state.sortField,
        sortOrder: this.state.sortOrder,
        statisticQuickDays: this.state.statisticQuickDays,
      }),
    );
  };

  restoreQueryCache = () => {
    const cache = window.sessionStorage.getItem(QUERY_CACHE_KEY);
    if (!cache) return false;

    window.sessionStorage.removeItem(QUERY_CACHE_KEY);
    try {
      const {
        fieldsValue = {},
        pageNo = 1,
        sortField,
        sortOrder,
        statisticQuickDays,
      } = JSON.parse(cache) || {};
      const restoredFieldsValue = { ...fieldsValue };
      DATE_FIELD_NAMES.forEach((fieldName) => {
        if (Array.isArray(restoredFieldsValue[fieldName])) {
          restoredFieldsValue[fieldName] = restoredFieldsValue[fieldName].map((date) => moment(date));
        }
      });
      this.props.form.setFieldsValue(restoredFieldsValue);
      this.setState(
        { pageNo, sortField, sortOrder, statisticQuickDays },
        () => this.getStallAnalyseData(this.getSearchParams(pageNo)),
      );
      return true;
    } catch (e) {
      return false;
    }
  };

  getMarketList = () => {
    this.props.marketList({});
  };

  getAllDistrictInfo = (params) => {
    this.props.getAllDistrictInfo(params);
  };

  getStallAnalyseData = (params) => {
    this.setState({ loading: true });
    this.props.getStallAnalyseData(params);
    this.setState({ loading: false, pageNo: params.pageNo || 1 });
  };

  disabledStatisticDate = (current) => {
    if (!current) return false;
    return current > moment().subtract(1, 'day').endOf('day') || current < moment().subtract(30, 'days').startOf('day');
  };

  setStatisticQuickDate = (days) => {
    const end = moment().subtract(1, 'day');
    const start = end.clone().subtract(days - 1, 'day');
    this.props.form.setFieldsValue({ statisticDate: [start, end] });
    this.setState({ statisticQuickDays: days });
  };

  getSearchParams = (pageNo = 1, extra = {}) => {
    const fieldsValue = this.props.form.getFieldsValue(QUERY_FIELD_NAMES);
    const statisticDate = fieldsValue.statisticDate || DEFAULT_STATISTIC_DATE;
    const pactStartTime = fieldsValue.pactStartTime || [];
    const createTime = fieldsValue.createTime || [];
    const sleepTime = fieldsValue.sleepTime || [];
    const sortField = extra.sortField !== undefined ? extra.sortField : this.state.sortField;
    const sortOrder = extra.sortOrder !== undefined ? extra.sortOrder : this.state.sortOrder;

    return {
      businessCode: fieldsValue.businessCode || null,
      name: fieldsValue.name || null,
      districtList: fieldsValue.districtList || null,
      marketIdList: fieldsValue.marketIdList || null,
      queryStartTime: statisticDate.length === 2 ? toStartTime(statisticDate[0]) : null,
      queryEndTime: statisticDate.length === 2 ? toEndTime(statisticDate[1]) : null,
      pactStartTimeStart: pactStartTime.length === 2 ? toStartTime(pactStartTime[0]) : null,
      pactStartTimeEnd: pactStartTime.length === 2 ? toEndTime(pactStartTime[1]) : null,
      createTimeStart: createTime.length === 2 ? toStartTime(createTime[0]) : null,
      createTimeEnd: createTime.length === 2 ? toEndTime(createTime[1]) : null,
      typeList: (fieldsValue.typeList || []).filter((type) => type !== 1),
      enableList: [true],
      activeStatusList:
        fieldsValue.activeStatusList && fieldsValue.activeStatusList.length === 2
          ? []
          : fieldsValue.activeStatusList || [],
      sleepTimeStart: sleepTime.length === 2 ? toStartTime(sleepTime[0]) : null,
      sleepTimeEnd: sleepTime.length === 2 ? toEndTime(sleepTime[1]) : null,
      pageNo,
      pageSize: DEFAULT_PAGE_SIZE,
      sortField,
      sortOrder: sortOrder === 'ascend' ? 'asc' : sortOrder === 'descend' ? 'desc' : undefined,
    };
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.props.form.validateFields((errors) => {
      if (errors) return;
      this.getStallAnalyseData(this.getSearchParams(1));
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.form.setFieldsValue({
      statisticDate: DEFAULT_STATISTIC_DATE,
    });
    this.setState({ sortField: undefined, sortOrder: undefined, statisticQuickDays: 1 });
    this.getStallAnalyseData(this.getSearchParams(1, { sortField: undefined, sortOrder: undefined }));
  };

  paginationChange = (pagination, filters, sorter = {}) => {
    this.setState(
      { pageNo: pagination.current, sortField: sorter.field, sortOrder: sorter.order },
      () => {
        this.props.form.validateFields((errors) => {
          if (errors) return;
          this.getStallAnalyseData(
            this.getSearchParams(pagination.current, {
              sortField: sorter.field,
              sortOrder: sorter.order,
            }),
          );
        });
      },
    );
  };

  toStallDetail = (stallId) => {
    if (!stallId) return;
    this.saveQueryCache();
    this.props.history.push({
      pathname: '/booth/stallManager/stallManagementDetail',
      state: { stallId, from: 'GO_BACK' },
    });
  };

  openUsageDetail = async (record) => {
    if (!record || !record.stallId) return;
    const detailQuery = {
      ...this.getSearchParams(1),
      sortField: null,
      sortOrder: null,
    };
    this.setState({
      detailVisible: true,
      detailLoading: true,
      detailRecord: record,
      detailRows: [],
      detailQueryStartTime: detailQuery.queryStartTime,
      detailQueryEndTime: detailQuery.queryEndTime,
    });
    try {
      const res = await this.props.getStallAnalyseDetail({
        ...detailQuery,
        stallId: record.stallId,
      });
      const responseData = res && res.data !== undefined ? res.data : res;
      const detailRows = Array.isArray(responseData)
        ? responseData
        : responseData && Array.isArray(responseData.data)
          ? responseData.data
          : responseData && Array.isArray(responseData.pageList)
            ? responseData.pageList
            : [];
      this.setState({ detailRows, detailLoading: false });
    } catch (e) {
      this.setState({ detailLoading: false });
    }
  };

  closeUsageDetail = () => {
    this.setState({
      detailVisible: false,
      detailRecord: null,
      detailRows: [],
      detailQueryStartTime: null,
      detailQueryEndTime: null,
    });
  };

  renderUsageDetail = () => {
    const {
      detailRecord,
      detailRows,
      detailLoading,
      detailQueryStartTime,
      detailQueryEndTime,
    } = this.state;
    if (!detailRecord) return null;
    const rangeStart = moment(detailQueryStartTime).startOf('day');
    const rangeEnd = moment(detailQueryEndTime - 1).startOf('day');
    const rangeDays = Math.max(rangeEnd.diff(rangeStart, 'days') + 1, 1);
    const detailRangeLabel =
      rangeDays === 1
        ? `${rangeStart.format('YYYY-MM-DD')}（${
            rangeStart.isSame(moment().subtract(1, 'day'), 'day') ? '昨天' : '当日'
          }）`
        : `${rangeStart.format('YYYY-MM-DD')} ~ ${rangeEnd.format('YYYY-MM-DD')}（共${rangeDays}天）`;
    const rows = (detailRows || [])
      .slice()
      .sort((a, b) => (b.statDate || 0) - (a.statDate || 0));
    const versionText = VERSION_MAP.get(detailRecord.type) || '-';
    const lockedMetrics = LOCKED_METRIC_BY_VERSION[versionText] || [];
    const isLocked = (dataIndex) => lockedMetrics.indexOf(dataIndex) >= 0;
    const getMetricValue = (row, dataIndex) => {
      if (isLocked(dataIndex)) return '-';
      const value = row[dataIndex];
      return value === undefined || value === null ? 0 : value;
    };
    const formatDetailValue = (value, dataIndex) => {
      if (value === '-') return value;
      if (dataIndex === 'gmv') {
        return Number(value || 0).toLocaleString('zh-CN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return Number(value || 0).toLocaleString('zh-CN');
    };
    const total = METRIC_COLUMNS.reduce((result, item) => {
      result[item.dataIndex] = isLocked(item.dataIndex)
        ? '-'
        : rows.reduce((sum, row) => sum + Number(getMetricValue(row, item.dataIndex) || 0), 0);
      return result;
    }, {});
    const detailColumns = [
      {
        title: '日期',
        dataIndex: 'statDate',
        key: 'statDate',
        fixed: 'left',
        width: 132,
        render: (value) => {
          const date = moment(value);
          return <span className='usage-detail-date-only'>{date.format('YYYY-MM-DD')}</span>;
        },
      },
      ...METRIC_COLUMNS.map((item) => ({
        title: item.title,
        dataIndex: item.dataIndex,
        key: item.dataIndex,
        className: item.className,
        width: item.width || (item.dataIndex === 'gmv' ? 140 : 100),
        render: (_, row) => formatDetailValue(getMetricValue(row, item.dataIndex), item.dataIndex),
      })),
    ];
    const summaryItems = [
      ['开单单量（不含白条）', 'orderNum', ''],
      ['开单GMV', 'gmv', '元'],
      ['录赊欠（白条）', 'btOrderCount', ''],
      ['买家还款', 'repaymentCount', ''],
    ];
    const status = ACTIVE_STATUS_MAP[detailRecord.activeStatus];
    return (
      <Modal
        title={`商行使用数据详情 · ${detailRecord.stallName || '-'}`}
        open={this.state.detailVisible}
        onCancel={this.closeUsageDetail}
        footer={null}
        width={1180}
        centered
        getContainer={false}
        destroyOnClose
        className='usage-detail-modal'
      >
        <div className='usage-detail-meta'>
          <span>{detailRecord.businessCode || '-'}</span>
          <span className='usage-detail-divider'>|</span>
          <span className={`usage-detail-badge ${VERSION_BADGE_CLASS_MAP[versionText] || 'badge--jbn'}`}>
            {versionText}
          </span>
          {status && (
            <span className={`usage-detail-status usage-detail-status--${status.text === '活跃' ? 'active' : 'sleep'}`}>
              <i className='usage-detail-status-dot' />
              {status.text}
            </span>
          )}
          <span className='usage-detail-divider'>|</span>
          <span>{[detailRecord.provinceName, detailRecord.cityName].filter(Boolean).join(' ') || '-'}</span>
          <span className='usage-detail-divider'>|</span>
          <span>{detailRecord.marketName || '-'}</span>
          <span className='usage-detail-divider'>|</span>
          <span>统计区间 {detailRangeLabel}</span>
        </div>
        <div className='usage-detail-summary'>
          {summaryItems.map(([label, key, unit]) => (
            <div className='usage-detail-summary-item' key={key}>
              <div className='usage-detail-summary-label'>{label}（{rangeDays === 1 ? '当日' : '区间合计'}）</div>
              <div className='usage-detail-summary-value'>
                {formatDetailValue(total[key], key)}{unit && total[key] !== '-' && <small>{unit}</small>}
              </div>
            </div>
          ))}
        </div>
        <div className='usage-detail-grid'>
          <Table
            className='usage-detail-table'
            rowKey={(record) => record.statDate}
            columns={detailColumns}
            dataSource={rows}
            loading={detailLoading}
            pagination={false}
            scroll={{ x: 1420, y: 360 }}
          />
        </div>
        <div className='usage-detail-footer'>
          <Button type='primary' onClick={this.closeUsageDetail}>关闭</Button>
        </div>
      </Modal>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading, pageNo, statisticQuickDays } = this.state;
    const {
      mergeSet: {
        districtInfo: { mapping },
      },
      stall: { marketData = [], boothBillData = {} },
    } = this.props;
    const { origins } = mapping || [];
    const { pageList = [], totalSize = 0 } = boothBillData;
    const cityOptions = Array.isArray(origins) ? origins : [];
    if (cityOptions instanceof Array) {
      for (const iterator of cityOptions) {
        for (const iteratorChildren of iterator.children || []) {
          delete iteratorChildren.children;
        }
      }
    }
    const pagination = { current: pageNo, pageSize: DEFAULT_PAGE_SIZE, total: totalSize };
    const formItemLayout = {
      labelCol: { style: { width: 82 } },
      wrapperCol: { style: { flex: 1, width: 0 } },
    };
    const colProps = {
      xs: 24,
      sm: 24,
      md: 12,
      lg: 12,
      xl: 8,
      xxl: 6,
      className: 'query-col',
    };
    const dateQuickColProps = {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 16,
      xxl: 12,
      className: 'query-col',
    };
    const actionColProps = {
      xs: 24,
      sm: 24,
      md: 12,
      lg: 12,
      xl: 8,
      xxl: 6,
      className: 'query-action-col',
    };

    const columns = [
      { title: '商行业务ID', dataIndex: 'businessCode', width: 110, fixed: 'left' },
      {
        title: '商行名称',
        dataIndex: 'stallName',
        width: 180,
        fixed: 'left',
        render: (text, record) => {
          const stallName = text || '-';
          if (!record.stallId) {
            return <span title={stallName}>{stallName}</span>;
          }
          return (
            <span
              className='stall-name-link'
              title={stallName}
              onClick={() => this.toStallDetail(record.stallId)}
            >
              {stallName}
            </span>
          );
        },
      },
      {
        title: '活跃状态',
        dataIndex: 'activeStatus',
        width: 100,
        fixed: 'left',
        render: (_, record) => {
          const value = record.activeStatus === undefined ? record.stallStatus : record.activeStatus;
          const status = ACTIVE_STATUS_MAP[value];
          return status ? (
            <span className={`usage-detail-status usage-detail-status--${status.text === '活跃' ? 'active' : 'sleep'}`}>
              <i className='usage-detail-status-dot' />
              {status.text}
            </span>
          ) : '-';
        },
      },
      {
        title: '商行版本',
        dataIndex: 'type',
        width: 100,
        render: (text) => VERSION_MAP.get(text) || '--',
      },
      { title: '创建时间', dataIndex: 'createTime', width: 130, sorter: true, render: (text) => renderDate(text) },
      { title: '签约时间', dataIndex: 'pactStartTime', width: 120, render: (text) => renderDate(text) },
      { title: '沉睡时间', dataIndex: 'sleepTime', width: 120, sorter: true, render: (text) => renderDate(text) },
      {
        title: '所在省份',
        dataIndex: 'provinceName',
        width: 140,
        render: (text) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>,
      },
      {
        title: '所在城市',
        dataIndex: 'cityName',
        width: 140,
        render: (text) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>,
      },
      { title: '市场名称', dataIndex: 'marketName', width: 180, render: (text) => text || '-' },
      ...METRIC_COLUMNS.map((item) => ({
        ...item,
        width: item.width || (item.dataIndex === 'gmv' ? 140 : 100),
        sorter: true,
        render: (text, record) =>
          renderMetricValue(text !== undefined && text !== null ? text : record[item.fallbackDataIndex]),
      })),
      {
        title: '操作',
        key: 'detail',
        fixed: 'right',
        width: 80,
        render: (_, record) => (
          <Button className='usage-detail-action' type='link' onClick={() => this.openUsageDetail(record)}>
            详情
          </Button>
        ),
      },
    ];

    return (
      <PageHeaderLayout>
        <div className='data-analysis stall-health-like-container'>
          <Card bordered={false} bodyStyle={{ padding: '0 0 16px 16px' }}>
            <Form
              className='ant-advanced-search-form'
              layout='inline'
              colon={false}
              onSubmit={this.handleSearch}
              {...formItemLayout}
            >
              <Row className='query-row'>
                <Col {...colProps}>
                  <FormItem label='商行业务ID'>
                    {getFieldDecorator('businessCode')(
                      <Input style={{ width: '100%' }} allowClear placeholder='请输入商行业务ID' />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='商行名称'>
                    {getFieldDecorator('name')(
                      <Input style={{ width: '100%' }} allowClear placeholder='请输入商行名称' />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='城市'>
                    {getFieldDecorator('districtList')(
                      <TreeSelect
                        allowClear
                        showSearch
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={cityOptions}
                        placeholder='请选择城市'
                        treeDefaultExpandAll={false}
                        filterTreeNode={(input, treeNode) => {
                          return treeNode.props.title.indexOf(input) >= 0;
                        }}
                        multiple
                        maxTagCount={2}
                      />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='市场名称'>
                    {getFieldDecorator('marketIdList')(
                      <Select
                        style={{ width: '100%' }}
                        mode='multiple'
                        allowClear
                        showSearch
                        placeholder='请选择市场'
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {marketData.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
                <Col {...dateQuickColProps}>
                  <FormItem label='统计日期'>
                    <div className='statistic-date-control'>
                      {getFieldDecorator('statisticDate', { initialValue: DEFAULT_STATISTIC_DATE })(
                        <RangePicker
                          className='statistic-date-picker'
                          disabledDate={this.disabledStatisticDate}
                          format='YYYY-MM-DD'
                          placeholder={['开始时间', '结束时间']}
                          onChange={() => this.setState({ statisticQuickDays: undefined })}
                        />,
                      )}
                      <div className='quick-date statistic-quick-control'>
                        {[1, 7, 30].map((days) => (
                          <Button
                            key={days}
                            size='small'
                            htmlType='button'
                            type={statisticQuickDays === days ? 'primary' : 'default'}
                            onClick={() => this.setStatisticQuickDate(days)}
                          >
                            {days === 1 ? '昨天' : `近${days}天`}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='签约时间'>
                    {getFieldDecorator('pactStartTime')(
                      <RangePicker style={{ width: '100%' }} format='YYYY-MM-DD' placeholder={['开始时间', '结束时间']} />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='创建时间'>
                    {getFieldDecorator('createTime')(
                      <RangePicker style={{ width: '100%' }} format='YYYY-MM-DD' placeholder={['开始时间', '结束时间']} />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='沉睡时间'>
                    {getFieldDecorator('sleepTime')(
                      <RangePicker style={{ width: '100%' }} format='YYYY-MM-DD' placeholder={['开始时间', '结束时间']} />,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='商行版本'>
                    {getFieldDecorator('typeList')(
                      <Select
                        mode='multiple'
                        style={{ width: '100%' }}
                        placeholder='请选择商行版本'
                        maxTagCount={2}
                        allowClear
                      >
                        {VERSION_OPTIONS.map(([k, v]) => (
                          <Select.Option value={k} key={k}>
                            {v}
                          </Select.Option>
                        ))}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
                <Col {...colProps}>
                  <FormItem label='活跃状态'>
                    {getFieldDecorator('activeStatusList')(
                      <Checkbox.Group>
                        <Checkbox value={1}>活跃</Checkbox>
                        <Checkbox value={0}>沉睡</Checkbox>
                      </Checkbox.Group>,
                    )}
                  </FormItem>
                </Col>
                <Col {...actionColProps}>
                  <div className='query-actions'>
                    <Button type='primary' htmlType='submit'>查询</Button>
                    <Button onClick={this.handleReset}>重置</Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>

          <Card bordered={false} style={{ marginTop: 8 }}>
            <Table
              dataSource={pageList}
              columns={columns}
              pagination={pagination}
              rowKey={(record) => record.stallId || record.businessCode}
              align='center'
              bordered
              onChange={this.paginationChange}
              scroll={{ x: 2100 }}
              loading={loading}
            />
          </Card>
          {this.renderUsageDetail()}
        </div>
      </PageHeaderLayout>
    );
  }
}

export default DataAnalysis;
